import { throttle } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  chatIsEnabledSelector,
  chatIsOpacityModeSelector,
  chatIsOpenSelector,
  messageSelector,
  messagesSelector,
  setOpacityMode,
} from "@/domains/chat/slice";

export default () => {
  const dispatch = useAppDispatch();
  const isOpacityMode = useAppSelector(chatIsOpacityModeSelector);
  const chatIsEnabled = useAppSelector(chatIsEnabledSelector);
  const chatIsOpen = useAppSelector(chatIsOpenSelector);
  const messages = useAppSelector(messagesSelector);
  const message = useAppSelector(messageSelector);
  const [isMouseOnChat, setIsMouseOnChat] = useState(false);
  const ref = useRef(Number(new Date()));

  useEffect(() => {
    ref.current = Number(new Date());

    if (!chatIsEnabled) {
      const interval = setInterval(() => {
        if (Number(new Date()) - ref.current > 10 * 1000) {
          dispatch(setOpacityMode(true));
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }

    dispatch(setOpacityMode(false));

    return () => {};
  }, [isOpacityMode, messages, chatIsEnabled, message, dispatch]);

  const turnOffOpacityMode = useCallback(
    throttle(
      () => {
        dispatch(setOpacityMode(false));
      },
      100,
      {
        trailing: true,
        leading: true,
      },
    ),
    [dispatch],
  );

  const onMouseEnterHandler = useCallback(() => {
    setIsMouseOnChat(true);
  }, []);
  const onMouseLeaveHandler = useCallback(() => {
    setIsMouseOnChat(false);
  }, []);

  return {
    turnOffOpacityMode,
    isOpacityMode: chatIsOpen && isOpacityMode && !isMouseOnChat,
    isMouseOnChat,
    onMouseEnterHandler,
    onMouseLeaveHandler,
  };
};
